/**
 * CRO Digest — Subscription First
 * UX: Abonnement is default. Eenmalig is verborgen achter een toggle.
 */

(function () {
  'use strict';

  const SUB_VARIANT_ID = window.livera_digest_sub_variant || 53854260035930;
  const SUB_PLAN_ID    = window.livera_digest_plan_90d    || 692199063898;

  const state = {
    onetimeVariantId: null,
    onetimeMidVariantId: null,
  };

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  function initStickyBar() {
    const bar = $('#cro-sticky-bar');
    if (!bar) return;
    const hero = $('.cro-hero');
    if (hero) {
      const obs = new IntersectionObserver(([e]) => {
        bar.classList.toggle('is-visible', !e.isIntersecting);
        bar.setAttribute('aria-hidden', e.isIntersecting ? 'true' : 'false');
      }, { threshold: 0.1 });
      obs.observe(hero);
    }
  }

  function initGallery() {
    const mainImg = $('#cro-main-img');
    if (!mainImg) return;
    $$('.cro-gallery__thumb').forEach(btn => {
      btn.addEventListener('click', () => {
        mainImg.src = btn.dataset.src;
        $$('.cro-gallery__thumb').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
      });
    });
  }

  function initCounters() {
    const viewEl = $('#cro-viewers');
    if (viewEl) {
      let v = 18 + Math.floor(Math.random() * 20);
      viewEl.textContent = v;
      setInterval(() => {
        v += (Math.random() > 0.5 ? 1 : -1);
        v = Math.max(10, Math.min(45, v));
        viewEl.textContent = v;
      }, 7000);
    }
    const buyEl = $('#cro-buyers-today');
    if (buyEl) buyEl.textContent = 38 + Math.floor(Math.random() * 20);
    const stockEl = $('#cro-stock-count');
    if (stockEl) stockEl.textContent = 8 + Math.floor(Math.random() * 10);
  }

  function initOnetimeToggle(toggleId, panelId, atcId, isMid) {
    const btn   = $(toggleId);
    const panel = $(panelId);
    if (!btn || !panel) return;

    btn.addEventListener('click', () => {
      const isOpen = panel.classList.contains('csf-onetime-panel--open');
      panel.classList.toggle('csf-onetime-panel--open', !isOpen);
      panel.setAttribute('aria-hidden', isOpen ? 'true' : 'false');
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });

    $$('.csf-onetime-card', panel).forEach(card => {
      card.addEventListener('click', () => {
        $$('.csf-onetime-card', panel).forEach(c => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
        const radio = $('input[type="radio"]', card);
        if (radio) radio.checked = true;

        if (isMid) {
          state.onetimeMidVariantId = card.dataset.variantId;
        } else {
          state.onetimeVariantId = card.dataset.variantId;
        }

        const atcBtn = $(atcId);
        if (atcBtn) atcBtn.style.display = 'flex';
      });
    });
  }

  function handleATC(e) {
    const id = e.currentTarget.id;
    let variantId, sellingPlan;

    if (id === 'csf-onetime-atc-btn') {
      variantId   = state.onetimeVariantId;
      sellingPlan = '';
    } else if (id === 'csf-onetime-atc-mid') {
      variantId   = state.onetimeMidVariantId;
      sellingPlan = '';
    } else {
      variantId   = SUB_VARIANT_ID;
      sellingPlan = SUB_PLAN_ID;
    }

    if (!variantId) return;

    const variantInput = $('#cro-variant-id');
    const planInput    = $('#cro-selling-plan-id');
    if (variantInput) variantInput.value = variantId;
    if (planInput) {
      if (sellingPlan) {
        planInput.value    = sellingPlan;
        planInput.disabled = false;
        planInput.name     = 'selling_plan';
      } else {
        planInput.value    = '';
        planInput.disabled = true;
        planInput.name     = '';
      }
    }

    const form = $('#cro-product-form');
    if (form) form.submit();
  }

  function initATCButtons() {
    ['cro-atc-btn', 'cro-mid-atc-btn', 'cro-final-atc-btn', 'cro-sticky-atc-btn',
     'csf-onetime-atc-btn', 'csf-onetime-atc-mid'].forEach(id => {
      const btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', handleATC);
    });
  }

  function initFAQ() {
    $$('.cro-faq__item').forEach(item => {
      const summary = $('summary', item);
      if (summary) {
        summary.addEventListener('click', () => {
          $$('.cro-faq__item[open]').forEach(open => {
            if (open !== item) open.removeAttribute('open');
          });
        });
      }
    });
  }

  function initScrollReveal() {
    if (!('IntersectionObserver' in window)) return;
    const targets = $$('.cro-mechanism__card, .cro-review-card, .cro-timeline__step, .cro-stat');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.style.opacity = '1';
          e.target.style.transform = 'translateY(0)';
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    targets.forEach(el => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      obs.observe(el);
    });
  }

  /* ─── Subscription accordion (IM8-style) ────────────── */
  function initOneAccordion(accordion) {
    if (!accordion) return;

    accordion.querySelectorAll('.csf-acc-item').forEach(item => {
      item.addEventListener('click', (e) => {
        // Don't collapse if clicking the ATC button
        if (e.target.closest('.csf-atc-btn')) return;

        const isActive = item.classList.contains('csf-acc-item--active');
        if (isActive) return; // already open

        // Collapse all
        accordion.querySelectorAll('.csf-acc-item').forEach(i => {
          i.classList.remove('csf-acc-item--active');
          const radio = i.querySelector('.csf-acc-radio');
          if (radio) radio.classList.remove('csf-acc-radio--active');
          const body = i.querySelector('.csf-acc-item__body');
          if (body) body.classList.remove('csf-acc-item__body--open');
        });

        // Expand clicked
        item.classList.add('csf-acc-item--active');
        const radio = item.querySelector('.csf-acc-radio');
        if (radio) radio.classList.add('csf-acc-radio--active');
        const body = item.querySelector('.csf-acc-item__body');
        if (body) body.classList.add('csf-acc-item__body--open');

        // Update globals for ATC
        window.livera_digest_sub_variant = item.dataset.variant;
        window.livera_digest_plan_90d    = item.dataset.planId;

        // Update sticky bar
        const stickyPD = document.getElementById('sticky-per-day');
        if (stickyPD) stickyPD.innerHTML = item.dataset.perDay + '<small>/dag</small>';
      });
    });

    // Wire ATC buttons inside accordion
    accordion.querySelectorAll('.csf-atc-btn').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const item      = btn.closest('.csf-acc-item');
        const variantId = item.dataset.variant;
        const planId    = item.dataset.planId;
        const price     = item.dataset.price;
        const locale    = document.documentElement.lang || 'nl';
        const base      = locale === 'nl' ? '' : '/' + locale;
        const url       = base + '/cart/add?id=' + variantId + '&quantity=1&selling_plan=' + planId;
        fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
          .then(() => { window.location.href = base + '/checkout'; })
          .catch(() => { window.location.href = base + '/cart'; });
      });
    });
  }

  function initSubAccordion() {
    initOneAccordion(document.getElementById('csf-sub-accordion'));
    initOneAccordion(document.getElementById('csf-sub-accordion-mid'));
  }

  document.addEventListener('DOMContentLoaded', () => {
    initStickyBar();
    initGallery();
    initCounters();
    initATCButtons();
    initFAQ();
    initScrollReveal();
    initSubAccordion();
    initOnetimeToggle('#csf-onetime-toggle-btn', '#csf-onetime-panel', '#csf-onetime-atc-btn', false);
    initOnetimeToggle('#csf-onetime-toggle-mid', '#csf-onetime-panel-mid', '#csf-onetime-atc-mid', true);
  });

})();
